<template>
  <div>
    <div>
      <div class="col-md-12">
        <img src="@/assets/images/logo/enviame.svg" alt="login" class="mx-auto mt-2" width="200">
      </div>
      <hr>
      
      <div class="center-view"> 
        <div class="main-section">
          <!-- Seccion izquierda -->
          <div class="border-right">
            <div id="img-section" class="info-section">
              <div>
                <svg class="" width="330" height="330" viewBox="0 0 330 330" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M299.2 179.919L283.319 151.25L275.619 137.5C273.375 133.36 270.06 129.899 266.02 127.48C261.981 125.061 257.365 123.773 252.656 123.75H200.681C198.522 127.521 195.758 130.912 192.5 133.787C190.566 135.519 188.471 137.061 186.244 138.394L184.8 139.15C182.949 140.195 181.018 141.092 179.025 141.831C174.533 143.487 169.787 144.347 165 144.375C154.06 144.375 143.568 140.029 135.832 132.293C128.096 124.557 123.75 114.065 123.75 103.125C123.757 100.823 123.941 98.5242 124.3 96.25H55C47.7065 96.25 40.7118 99.1473 35.5546 104.305C30.3973 109.462 27.5 116.457 27.5 123.75V226.875C27.5 234.168 30.3973 241.163 35.5546 246.32C40.7118 251.478 47.7065 254.375 55 254.375H55.6875C57.2654 262.146 61.4813 269.132 67.6207 274.15C73.7602 279.168 81.4457 281.909 89.375 281.909C97.3043 281.909 104.99 279.168 111.129 274.15C117.269 269.132 121.485 262.146 123.062 254.375H206.938C208.515 262.146 212.731 269.132 218.871 274.15C225.01 279.168 232.696 281.909 240.625 281.909C248.554 281.909 256.24 279.168 262.379 274.15C268.519 269.132 272.735 262.146 274.313 254.375H276.238C283.203 254.375 289.883 251.608 294.808 246.683C299.733 241.758 302.5 235.078 302.5 228.112V192.5C302.5 188.092 301.363 183.759 299.2 179.919ZM275 165L282.562 178.75L286.413 185.625H240.625C238.802 185.625 237.053 184.901 235.764 183.611C234.474 182.322 233.75 180.573 233.75 178.75V171.875C233.75 170.052 234.474 168.303 235.764 167.014C237.053 165.724 238.802 165 240.625 165H275ZM89.375 268.125C84.5717 268.11 79.9241 266.42 76.2341 263.345C72.5441 260.27 70.0431 256.003 69.1625 251.281C68.8861 250.04 68.7477 248.772 68.75 247.5C68.75 242.03 70.923 236.784 74.7909 232.916C78.6589 229.048 83.9049 226.875 89.375 226.875C94.8451 226.875 100.091 229.048 103.959 232.916C107.827 236.784 110 242.03 110 247.5C110.002 248.772 109.864 250.04 109.587 251.281C108.707 256.003 106.206 260.27 102.516 263.345C98.8259 266.42 94.1783 268.11 89.375 268.125ZM123.062 240.625V240.006C122.658 238.155 122.107 236.338 121.412 234.575L120.312 232.375C119.799 231.232 119.202 230.129 118.525 229.075L116.875 226.875C116.2 225.957 115.465 225.084 114.675 224.262C114.063 223.547 113.396 222.881 112.681 222.269L110 220C109.248 219.433 108.468 218.905 107.662 218.419L104.5 216.7L102.094 215.6C100.815 215.106 99.5059 214.692 98.175 214.362L96.25 213.812C91.9441 212.895 87.4934 212.895 83.1875 213.812L81.0563 214.362C79.7253 214.692 78.4165 215.106 77.1375 215.6L74.7313 216.7L71.5687 218.419C70.599 218.89 69.6578 219.418 68.75 220L66.1375 222.2C65.4224 222.812 64.7558 223.479 64.1437 224.194C63.3281 225.035 62.5701 225.931 61.875 226.875L60.225 229.144C59.5481 230.198 58.9506 231.301 58.4375 232.444C58.4375 233.2 57.6813 233.887 57.3375 234.644C56.6433 236.407 56.0915 238.223 55.6875 240.075V240.694H55C51.3533 240.694 47.8559 239.245 45.2773 236.666C42.6987 234.088 41.25 230.59 41.25 226.944V123.75C41.25 120.103 42.6987 116.606 45.2773 114.027C47.8559 111.449 51.3533 110 55 110H110.619C112.113 122.353 117.819 133.813 126.775 142.45C136.996 152.444 150.705 158.066 165 158.125C169.636 158.109 174.253 157.532 178.75 156.406V185.625H75.625C73.8016 185.625 72.053 186.349 70.7636 187.639C69.4743 188.928 68.75 190.677 68.75 192.5C68.75 194.323 69.4743 196.072 70.7636 197.361C72.053 198.651 73.8016 199.375 75.625 199.375H178.75V240.625H123.062ZM240.625 268.125C235.822 268.11 231.174 266.42 227.484 263.345C223.794 260.27 221.293 256.003 220.413 251.281C220.136 250.04 219.998 248.772 220 247.5C220 242.03 222.173 236.784 226.041 232.916C229.909 229.048 235.155 226.875 240.625 226.875C246.095 226.875 251.341 229.048 255.209 232.916C259.077 236.784 261.25 242.03 261.25 247.5C261.252 248.772 261.114 250.04 260.837 251.281C259.957 256.003 257.456 260.27 253.766 263.345C250.076 266.42 245.428 268.11 240.625 268.125ZM288.75 228.112C288.732 231.425 287.408 234.598 285.065 236.94C282.723 239.283 279.55 240.607 276.238 240.625H274.313V240.006C273.908 238.155 273.357 236.338 272.663 234.575L271.562 232.375C271.049 231.232 270.452 230.129 269.775 229.075L268.125 226.875C267.45 225.957 266.715 225.084 265.925 224.262C265.313 223.547 264.646 222.881 263.931 222.269L261.25 220C260.498 219.433 259.718 218.905 258.913 218.419L255.75 216.7L253.344 215.6C252.065 215.106 250.756 214.692 249.425 214.362L247.5 213.812C243.194 212.895 238.743 212.895 234.437 213.812L232.306 214.362C230.975 214.692 229.666 215.106 228.388 215.6L225.981 216.7L222.819 218.419C221.849 218.89 220.908 219.418 220 220L217.388 222.2C216.672 222.812 216.006 223.479 215.394 224.194C214.578 225.035 213.82 225.931 213.125 226.875L211.475 229.144C210.798 230.198 210.201 231.301 209.688 232.444L208.587 234.644C207.893 236.407 207.342 238.223 206.938 240.075V240.694H192.5V150.7C195.784 148.741 198.85 146.436 201.644 143.825C203.919 141.838 206.013 139.652 207.9 137.294H252.656C254.889 137.298 257.08 137.899 259.003 139.035C260.925 140.172 262.508 141.802 263.587 143.756L267.644 151.25H240.625C235.155 151.25 229.909 153.423 226.041 157.291C222.173 161.159 220 166.405 220 171.875V178.75C220 184.22 222.173 189.466 226.041 193.334C229.909 197.202 235.155 199.375 240.625 199.375H288.75V228.112Z" fill="#044389"/>
                  <path d="M165 48.125C154.122 48.125 143.488 51.3507 134.444 57.3942C125.399 63.4376 118.349 72.0275 114.187 82.0774C110.024 92.1273 108.935 103.186 111.057 113.855C113.179 124.524 118.417 134.324 126.109 142.016C133.801 149.708 143.601 154.946 154.27 157.068C164.939 159.19 175.998 158.101 186.048 153.938C196.098 149.776 204.687 142.726 210.731 133.681C216.774 124.637 220 114.003 220 103.125C220 88.5381 214.205 74.5486 203.891 64.2341C193.576 53.9196 179.587 48.125 165 48.125Z" fill="#F18805"/>
                  <path d="M141.654 126.143H151V117.464H141.654V126.143ZM153.077 126.143H163.462V117.464H153.077V126.143ZM141.654 115.536H151V105.893H141.654V115.536ZM153.077 115.536H163.462V105.893H153.077V115.536ZM141.654 103.964H151V95.2857H141.654V103.964ZM165.538 126.143H175.923V117.464H165.538V126.143ZM153.077 103.964H163.462V95.2857H153.077V103.964ZM178 126.143H187.346V117.464H178V126.143ZM165.538 115.536H175.923V105.893H165.538V115.536ZM154.115 89.5V80.8214C154.115 80.5603 154.013 80.3343 153.807 80.1434C153.602 79.9526 153.358 79.8571 153.077 79.8571H151C150.719 79.8571 150.475 79.9526 150.27 80.1434C150.064 80.3343 149.962 80.5603 149.962 80.8214V89.5C149.962 89.7612 150.064 89.9872 150.27 90.178C150.475 90.3689 150.719 90.4643 151 90.4643H153.077C153.358 90.4643 153.602 90.3689 153.807 90.178C154.013 89.9872 154.115 89.7612 154.115 89.5ZM178 115.536H187.346V105.893H178V115.536ZM165.538 103.964H175.923V95.2857H165.538V103.964ZM178 103.964H187.346V95.2857H178V103.964ZM179.038 89.5V80.8214C179.038 80.5603 178.936 80.3343 178.73 80.1434C178.525 79.9526 178.281 79.8571 178 79.8571H175.923C175.642 79.8571 175.398 79.9526 175.193 80.1434C174.987 80.3343 174.885 80.5603 174.885 80.8214V89.5C174.885 89.7612 174.987 89.9872 175.193 90.178C175.398 90.3689 175.642 90.4643 175.923 90.4643H178C178.281 90.4643 178.525 90.3689 178.73 90.178C178.936 89.9872 179.038 89.7612 179.038 89.5ZM191.5 87.5714V126.143C191.5 127.187 191.089 128.092 190.267 128.855C189.445 129.618 188.471 130 187.346 130H141.654C140.529 130 139.555 129.618 138.733 128.855C137.911 128.092 137.5 127.187 137.5 126.143V87.5714C137.5 86.5268 137.911 85.6228 138.733 84.8594C139.555 84.096 140.529 83.7143 141.654 83.7143H145.808V80.8214C145.808 79.4955 146.316 78.3605 147.333 77.4163C148.35 76.4721 149.572 76 151 76H153.077C154.505 76 155.727 76.4721 156.744 77.4163C157.761 78.3605 158.269 79.4955 158.269 80.8214V83.7143H170.731V80.8214C170.731 79.4955 171.239 78.3605 172.256 77.4163C173.273 76.4721 174.495 76 175.923 76H178C179.428 76 180.65 76.4721 181.667 77.4163C182.684 78.3605 183.192 79.4955 183.192 80.8214V83.7143H187.346C188.471 83.7143 189.445 84.096 190.267 84.8594C191.089 85.6228 191.5 86.5268 191.5 87.5714Z" fill="#ECE8E8"/>
                </svg>
              </div>


              <!--Información del retiro  -->
              <div class="pickup-font" v-if="pickup">
                <!-- Identifier -->
                <div class="mb-2">
                  <span> <b> <feather-icon icon="HashIcon" size="1x"/> </b> {{ pickup.identifier || '--' }}</span>
                </div>

                <!-- Fecha de retiro -->
                <div class="mb-2">
                  <span> <b> <feather-icon icon="CalendarIcon" size="1x"/> </b> {{ pickup.format_pickup_date || '--' }}</span>
                </div>

                <!-- Rango horario -->
                <div class="mb-2">
                  <span> <b> <feather-icon icon="ClockIcon" size="1x"/> </b> {{ pickup.range_time || '--' }}</span>
                </div>

                <!-- Carrier -->
                <div class="mb-2">
                  <span> <b> <feather-icon icon="TruckIcon" size="1x"/> </b> {{ pickup.carrier.name || '--' }}</span>
                </div>

                <!-- Dirección -->
                <div class="mb-2">
                  <span> <b> <feather-icon icon="MapPinIcon" size="1x"/> </b> {{ pickup.censored_address || '--' }}</span>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Seccion derecha -->
          <div v-if="showEvaluationStatuses" class="col-md-12">
            <div id="form-section">
              <!-- Formulario -->
              <b-form class="col-sm-7 col-md-6 mx-auto">
                <h3 class="mb-3 title-font text-primary text-center">Evaluar retiro</h3>
                <b-form-group class="col-md-12 mb-3" v-slot="{ ariaDescribedby }">
                  <label for="select-reason" class="form-font mb-2">Seleccione una opción para evaluar el retiro</label>
                  <div class="d-flex justify-content-between">
                    <b-form-radio class="mx-5" v-model="form.status" name="status-radios" value="DONE" :aria-describedby="ariaDescribedby">
                      <span class="custom-radio">Retirado</span>
                    </b-form-radio>
                    <b-form-radio class="mx-5" v-model="form.status" name="status-radios" value="FAILED" :aria-describedby="ariaDescribedby">
                      <span class="custom-radio">No retirado</span>
                    </b-form-radio>
                    <b-form-radio class="mx-5" v-model="form.status" name="status-radios" value="WAREHOUSE_DELIVERED" :aria-describedby="ariaDescribedby">
                      <span class="custom-radio">Entregado a sucursal</span>
                    </b-form-radio>
                  </div>
                </b-form-group>

                <b-form-group v-if="form.status" class="col-md-12" v-slot="{ ariaDescribedby }">
                  <label for="select-reason" class="form-font mb-2" v-if="titleReason"> {{ titleReason }} </label>
                  <div class="">
                    <b-form-radio v-for="(reason, index) in evaluationResons" :key="index" class="mx-5 mb-2" v-model="form.reason" name="reasons-radios" :value="reason.code" :aria-describedby="ariaDescribedby">
                      <span class="custom-radio">{{ reason.name }}</span>
                    </b-form-radio>
                  </div>
                </b-form-group>
                
                <div class="text-right mt-1">
                  <b-button @click="onSubmit" :disabled="disabled.evaluateButton" variant="warning">
                    {{$t('Confirmar')}}
                    <i v-if="loading.evaluateButton" :class="['fa', 'fa-spinner', 'fa-spin']"/> 
                  </b-button>
                </div>
              </b-form>

            </div>
          </div>

          <!-- Mensajes -->
          <div v-if="!showEvaluationStatuses" class="col-md-12 margin-message text-center">
            <h4 class="message-font"> {{ panelMessage }} </h4>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import PublicPickupsService from './public-pickups.service'
export default {
  data () {
    return {
      form: {},
      pickup: null,
      evaluationResons: null,
      showEvaluationStatuses: false,
      panelMessage: '',
      failedReasons: null,
      doneReasons: null,
      reasonStatuses: {
        done: 'DONE',
        failed: 'FAILED',
        warehouse_delivered: 'WAREHOUSE_DELIVERED'
      },
      titleReason: null,
      disabled: {
        evaluateButton: true
      },
      loading: {
        evaluateButton: false
      },
      PublicPickupsService: new PublicPickupsService(this)
    }
  },
  mounted () {
    this.initializeData()
  },
  watch: {
    'form.status' () {
      delete this.form.reason
      this.disabled.evaluateButton = true
      if (this.form.status === this.reasonStatuses.done) {
        this.evaluationResons = this.doneReasons
        this.titleReason = 'Indique en que franja horaria pasó el courier'
      } else if (this.form.status === this.reasonStatuses.failed) {
        this.evaluationResons = this.failedReasons
        this.titleReason = 'Indique el motivo'
      } else if (this.form.status === this.reasonStatuses.warehouse_delivered) {
        this.disabled.evaluateButton = false
        this.titleReason = ''
        this.evaluationResons = null
      }
    },
    'form.reason' () {
      if (this.form.reason) this.disabled.evaluateButton = false
      else this.disabled.evaluateButton = true
    }
  },
  methods: {
    initializeData () {
      // Activa el spinner de la plataforma
      this.PublicPickupsService.callService('getEvaluationData', null, { uuid: this.$route.params.uuid }, { fullResponseError: true })
        .then(resp => {
          // Mostrar estados de evaluación
          this.showEvaluationStatuses = true

          // Datos del retiro a mostrar en pantalla
          this.pickup = resp.data.pickup_data
          this.pickup.format_pickup_date = dayjs(resp.data.pickup_date).format('DD/MM/YYYY')
          this.pickup.censored_address  = this.censoredAddress(this.pickup.address.full_address)

          if (resp.data.pickup_data.evaluation) {
            this.showEvaluationStatuses = false
            this.panelMessage = 'El retiro ya ha sido evaluado. Muchas gracias.'
          } else {
            // Mostrar estados de evaluación
            this.showEvaluationStatuses = true
            // Estados de evaluación
            this.failedReasons = resp.data.evaluation_statuses.find(item => item.code === 'FAILED').reasons
            this.doneReasons = [
              {
                code: 'before',
                name: 'Antes de la franja horaria agendada'
              },
              {
                code: 'within',
                name: `En la franja horaria agendada (${this.pickup.range_time})`
              },
              {
                code: 'after',
                name: 'Después de la franja horaria agendada'
              }
            ]
          }
        })
        .catch(error => {
          this.panelMessage = error.data
        })
        .finally(() => {
          // Desactiva el spinner de la plataforma
        })
    },
    /**
     * Función que censura la dirección del retiro
     * @param {String} address dirección del retiro
     */
    censoredAddress (address) {
      const censorPercentage = 0.6
      const censoredChars = Math.floor(address.length * censorPercentage)
      // En caso de que la parte censurada tome el largo real de caracteres
      // const censoredPart = '*'.repeat(censoredChars)
      const censoredPart = '***'
      const visiblePart = address.slice(0, address.length - censoredChars)
      return visiblePart + censoredPart
    },
    onSubmit (event) {
      event.preventDefault()
      this.loading.evaluateButton = true
      this.disabled.evaluateButton = true
      const queryParams = {
        evaluation: {
          status: this.form.status.toLowerCase()
        }
      }
      if (this.form.status === this.reasonStatuses.done) {
        queryParams.evaluation.time_range = this.form.reason
      } else if (this.form.status === this.reasonStatuses.failed) {
        queryParams.evaluation.reasons = [this.form.reason]
      }

      this.PublicPickupsService.callService('evaluatePickup', queryParams, { uuid: this.$route.params.uuid })
        .then(resp => {
          this.showEvaluationStatuses = false
          this.panelMessage = 'Muchas gracias, el retiro ha sido evaluado con éxito.'
        })
        .catch(error => {
          console.error(error)
          this.$alert('Ha ocurrido un error inesperado.')
        })
        .finally(() => {
          this.loading.evaluateButton = false
          this.disabled.evaluateButton = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>

.title-font{
  font-size: 40px;
}
.message-font{
  font-size: 30px;
}
.form-font {
  font-size: 20px;
  font-weight: bold;
}
.pickup-font {
  font-size: 20px;
}

.margin-container {
  margin-top: 5%;
}
.margin-message {
  margin-top: 15%;
}
.border-right {
  border-right: 1px solid;
}
.custom-radio {
  font-size: 15px;
  // font-weight: bolder;
}

.main-section {
  display: grid;
  grid-template-columns: 40% 60%;
}
.info-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: left;
}

</style>